import { useLocation } from "react-router"

const useRoomcode = (): string => {
  const location = useLocation();
  return location.pathname.replace('/', '');
}

export default useRoomcode;
